import { post, postWithToken } from "@/api/http";
import store from "@/store/index";
import { apiHttp } from "@/api/index";
import { storageGet } from "@/utils";
import { storageKey } from "@/utils/config";
import { isBoolean } from "lodash";

// 获取用户信息
export const getUser = async () => {
  try {
    const res: any = await apiHttp.get("/ums/company-user/get-user-info");

    res.phone = res.mobile;
    return Promise.resolve({
      success: Boolean(res.id),
      data: res,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getMyUserInfo = () => apiHttp.get("/sys/user/profile");

// 获取用户企业信息
export const getCoInfo = async () => {
  try {
    const res: any = await apiHttp.get(
      `/ums/company/${storageGet(storageKey.company).id}`
    );
    return Promise.resolve({
      success: Boolean(res.id),
      ...res,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

// 获取企业列表
export const getCoList = () =>
  postWithToken("/signtrustv3/usr/GetCoList", {
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
  });

// 获取企业版已完成合约下载配置（在鲲泰中配置）
export const getCoConfig = () =>
  postWithToken("/signtrustv3/coconfig/getCoconfig", {
    coId: store.getters.coId,
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
  });

// 获取用户组织信息
export const getUserOrgByIds = (ids: number[]) =>
  postWithToken("/signtrustv3/usr/GetUsrsRolesOrgs", {
    ids,
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
  });

// 编辑用户 字段自选
export const editUser = async (info) => {
  try {
    const res: any = await apiHttp.put("/ums/company-user/update-user-info", {
      ...info,
    });
    return Promise.resolve({
      success: Boolean(res.id),
      data: res,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

// 编辑用户手机号
export const editUserPhone = async (newPhone: string, areaCode: string) => {
  try {
    const res: any = apiHttp.put("/ums/company-user/update-user-info", {
      areaCode: clearAreaPhoneCode(areaCode),
      mobile: newPhone,
    });
    return Promise.resolve({
      success: Boolean(res.id),
      ...res,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

// 编辑用户头像
export const editUserHeadImage = (imageId: number) =>
  postWithToken("/signtrustv3/usr/EditUsrPic", {
    id: store.getters.userId,
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
    usrPicFileId: imageId,
  });

// 检查登录名重复
export const checkLoginName = async (loginName: string) => {
  try {
    const res: any = await apiHttp.get("/sys/user/query-user", {
      params: {
        username: loginName,
      },
    });
    return Promise.resolve({
      success: true,
      exist: Boolean(res.id),
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

// 检查手机号存在
export const checkPhoneExist = async (phone: string, areaCode: string) => {
  try {
    const res: any = await apiHttp.post("/sys/user/check-phone-exist", {
      areaCode: clearAreaPhoneCode(areaCode),
      phone,
    });
    return Promise.resolve({
      exist: res === true,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

// 编辑用户登录名
export const editUsrLoginName = (loginName: string) => {
  try {
    const res: any = apiHttp.put("/ums/company-user/update-user-info", {
      username: loginName,
    });
    return Promise.resolve({
      success: Boolean(res.id),
      ...res,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

// 使用忘记密码作为修改密码
export const forgetPassword = (
  account: string,
  newPassword: string,
  smsCode: string
) =>
  postWithToken("/signtrustv3/usr/ForgetPwd", {
    newPwd: newPassword,
    smsCode,
    phoneOrEmail: account,
    usrId: store.getters.userId,
    usrPhone: store.getters.getUserPhone,
  });

// 验证用户实名认证信息
export const phoneVerification = async () => {
  try {
    const res: any = await apiHttp.post("/sys/user/phone-authentication");
    return Promise.resolve({
      success: res === true,
      data: res,
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
    });
  }
};

export const phoneVerificationStatusCode = {
  "0": "认证通过",
  "-4": "信息不一致",
  "-5": "手机号未实名",
  "-6": "手机号码不合法",
  "-7": "身份证号码有误",
  "-8": "姓名校验不通过",
  "-9": "没有记录",
  "-10": "认证未通过",
  "-11": "验证中心服务繁忙",
  "-12": "认证错误",
};

// 获取微信登录iframe链接
export const getBindWechatIframeUrl = () =>
  postWithToken(
    "/sys/user/get-binding-open-we-chat-login-qr-code-url?platform=1"
  );

// 绑定微信
export const bindUserWechat = (openWeChatCode: string) => {
  const formData = new FormData();
  formData.append("openWeChatCode", openWeChatCode);
  formData.append("platform", "1");
  return postWithToken(
    "/sys/user/user-binding-open-we-chat-login-qr-code-url",
    formData
  );
};

// 获取微信登录iframe链接
export const getLoginWechatIframeUrl = () =>
  post("/sys/user/get-open-we-chat-login-qr-code-url?platform=1");

// 微信登录
export const loginUserByWechat = (openWeChatCode: string, sofIds) =>
  post("/signtrustv3/usr/OpenWeChatQrCodeLogin", {
    openWeChatCode,
    sofIds,
  });

// 根据用户发送激活邮件
export const sendActivationEmail = async () => {
  try {
    const res: any = await apiHttp.post("/sys/user/send-activation-email");

    return Promise.resolve({
      success: res === true,
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
    });
  }
};

// 绑定邮箱
export const bindUserEmail = (emailCode: string) =>
  post("/signtrustv3/usr/CheckEmailActivation", {
    checkCode: emailCode,
  });

// 验证邮箱验证码
export const checkEmailCode = (email: string, code: number) =>
  post("/signtrustv3/usr/CheckEmailCode", {
    checkCode: code,
    usrEmail: email,
  });

// 清除区号前面的+号
export function clearAreaPhoneCode(code: string) {
  if (!code) return "";
  return code.split("+")[1] || code;
}

// 绑定邮箱
export const checkCoSof = () =>
  post("/signtrustv3/usr/CheckCoSof", {
    clientplatformId: 0,
    coId: store.getters.coId,
    ipAddress: "",
    sofId: store.state.sofId,
    usrId: store.getters.userId,
  });

// 绑定邮箱
export const getUsrCosByPhone = async (phone) => {
  try {
    const res: any = await apiHttp.post(
      "/sys/user/get-company-by-phone",
      {
        phone: phone,
        areaCode: "86",
      },
      {
        headers: {
          tenantId: false,
          companyId: false,
        },
      }
    );
    if (res.infos?.length) {
      // res.infos.forEach((item) => {
      //   item.coId = item.tenantId;
      //   item.coName = item.tenantName;
      // });
      return Promise.resolve({
        success: Boolean(res.infos),
        ...res,
      });
    }
    return Promise.resolve({
      success: false,
      infos: [],
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
      infos: [],
    });
  }
};

// 获取用户企业版签泰企业列表
export const getSigntrustCosByUsr = () =>
  postWithToken("/signtrustv3/usr/GetSigntrustCosByUsr", {
    clientplatformId: 0,
    usrPhone: store.getters.getUserPhone,
    usrId: store.getters.userId,
  });

// 获取用户签章列表
export const getUserSignList = (lockFilter = true) => {
  return new Promise<{ coimages: any[]; userimages: any[] }>(
    async (resolve, reject) => {
      try {
        const { list: userSignList }: any = await apiHttp.get(
          "/ums/user-sig/get-user-sig-list",
          {
            params: {
              lockFilter, // 是否过滤锁定签名
              lockOrder: 0, //锁定排序：0在后1在前，默认o
              userId: store.getters.userId,
            },
          }
        );
        const coSignList: any = await apiHttp.get(
          "/ums/company-sig/get-user-company-sigs",
          {
            params: {
              userId: store.getters.userId, // 是否过滤锁定签名
              companyId: store.getters.coId, //锁定排序：0在后1在前，默认o
            },
          }
        );
        resolve({
          coimages:
            coSignList?.map((item) => {
              item.check = item.isCheck;
              item.authorize = item.isAuthorize;
              item.fileId = item.sigFileId;
              item.signImageOss = "";
              return item;
            }) || [],
          userimages:
            userSignList?.map((item) => {
              item.default = item.isDefault;
              item.fileId = item.sigFileId;
              item.signImageOss = item.sigUrl;
              return item;
            }) || [],
        });
      } catch (e) {
        return reject(e);
      }
    }
  );
};

// 添加用户签章
export const addUserImageSign = ({ isDefault, fileAddress, fileId, title }) =>
  postWithToken("/ums/user-sig/add-usr-sig", {
    isDefault,
    fileAddress,
    sigFileId: fileId,
    title,
    usrPhone: localStorage.userPhone,
    userPhone: store.getters.getUserPhone,
    userId: store.getters.userId,
  });

export const getUsrInfoByUsrIds = (coSofInfos) =>
  postWithToken("/signtrustv3/usr/GetUsrInfoByUsrIds", {
    clientplatformId: 0,
    cosofInfos: coSofInfos,
    usrPhone: localStorage.userPhone,
    userPhone: store.getters.getUserPhone,
    usrId: store.getters.userId,
  });

export const copyFileSource = (fileId) =>
  postWithToken("/signtrustv3/usr/CoPyFileSource", {
    clientplatformId: 0,
    coId: store.getters.coId,
    fileId,
    operationUserId: store.getters.userId,
    usrId: store.getters.userId,
    sofId: store.getters.sofId,
    targetCoId: store.getters.coId,
    targetSofId: 95,
    type: 3,
  });

export const getSignatureFormat = () =>
  postWithToken("/signtrustv3/usersetting/getSignatureFormat", {
    clientplatformId: 0,
    coId: store.getters.coId,
    usrId: store.getters.userId,
    usrPhone: localStorage.userPhone,
  });

export const checkPassword = async (password) => {
  const formData = new FormData();
  formData.append("password", password);
  try {
    const res: any = await apiHttp.post("/ums/tenant-user/check-pwd", formData);
    return Promise.resolve({
      success: res === true,
    });
  } catch (error) {
    return Promise.resolve({
      success: false,
    });
  }
};

export const updateUserPassword = async (password: string) => {
  const form = new FormData();

  form.append("password", password);
  try {
    return Promise.resolve(
      apiHttp.post("/ums/tenant-user/update-user-password", form)
    );
  } catch (error) {
    return Promise.resolve({});
  }
};

export const getSigningStrategy = async () => {
  try {
    const res: any = await apiHttp.get("/ums/tenant_signing_strategy");

    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const checkSignPwd = async (password: string) => {
  const formData = new FormData();
  formData.append("password", password);
  try {
    const res: any = await apiHttp.post(
      "/ums/tenant-user/check-sign-pwd",
      formData
    );

    return Promise.resolve(isBoolean(res) ? res : false);
  } catch (error) {
    return Promise.resolve(false);
  }
};

export const tenantPasswordPolicy = async () => {
  try {
    return Promise.resolve(apiHttp.get("/ums/tenant-password-policy"));
  } catch (error) {
    return Promise.resolve({});
  }
};

export const isAdminBy = async () => {
  try {
    return Promise.resolve(await apiHttp.get("/ums/company-user/is-admin-by"));
  } catch (error) {
    return Promise.resolve(false);
  }
};
